<script setup>
import categoryTree from '@/preload/data/categories.json'
import config from '@/preload/data/config.json'
import { staticPages } from '@/preload/static.js'

const filteredTree = useAvailableCategoryTree(categoryTree)

useHead({
  title: `${config.pagetitle} | Sitemap`
})
</script>

<template>
  <div class="sitemap-page--wrap">
    <v-container class="py-15">
      <div class="text-h4 mb-10 font-weight-medium">
        Sitemap
      </div>

      <tree-view
        :items="filteredTree"
        hide-external-links
      />

      <v-list
        density="compact"
        class="pa-0"
        aria-label="Seiten"
      >
        <v-list-item
          v-for="page in staticPages"
          :key="page.path"
          :to="page.path"
          role="option"
        >
          <v-list-item-title class="pl-8">
            {{ page.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-container>
  </div>
</template>
